module.exports = __webpack_public_path__ + "static/media/reports_001.e112fc87.svg";